export const statisticsConstants={
  FETCH_ALL_STATISTICS_BEGIN: 'FETCH_ALL_STATISTICS_BEGIN',
  FETCH_ALL_STATISTICS_SUCCESS:'FETCH_ALL_STATISTICS_SUCCESS',
  FETCH_ALL_STATISTICS_ERROR:'FETCH_ALL_STATISTICS_ERROR'
};

